import type { Session } from "@mux/sdk/v2/client";

/**
 * Applies a `session.updated` payload to the session already known. Payloads
 * may be partial (a title change carries only `id` and `title`), so fields the
 * payload omits keep their current values.
 */
export function mergeSessionUpdate(existing: Session, info: Session): Session {
  return {
    ...existing,
    ...info,
    time: {
      ...existing.time,
      ...info.time,
      // Full session payloads omit archived when null; clear it so restore works.
      archived: info.time?.archived,
      updated: Math.max(
        existing.time?.updated ?? existing.time?.created ?? 0,
        info.time?.updated ?? info.time?.created ?? 0,
      ),
      activity: Math.max(
        existing.time?.activity ?? existing.time?.updated ?? existing.time?.created ?? 0,
        info.time?.activity ?? info.time?.updated ?? info.time?.created ?? 0,
      ),
    },
  };
}
